import { client } from "antdash";

const list = (data = {}) => client.get("transfers", data);

const transfersApi = {
  list,
};

export default transfersApi;
